import React from 'react';


const Payment = () => {
  return (
    <div className="min-h-screen bg-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-8 lg:gap-12">

        {/* Left Column: Payment Information */}
        <div className="lg:w-2/3 bg-white p-8 rounded-lg shadow-md">
          <h2 className="text-3xl font-extrabold text-gray-900 mb-6">Payment</h2>

          <div className="space-y-6">
            {/* Credit Card Section */}
            <div className="bg-blue-50 p-6 rounded-lg border border-blue-200">
              <div className="flex items-center mb-4">
                <input
                  id="credit-card"
                  name="payment-method"
                  type="radio"
                  checked
                  className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300"
                />
                <label htmlFor="credit-card" className="ml-3 block text-sm font-medium text-gray-700">
                  Credit Card
                </label>
              </div>

              <div className="space-y-4">
                <div>
                  <label htmlFor="cardholder-name" className="block text-sm font-medium text-gray-700">
                    Cardholder Name
                  </label>
                  <div className="mt-1">
                    <input
                      id="cardholder-name"
                      name="cardholder-name"
                      type="text"
                      autoComplete="cc-name"
                      placeholder="Jane Doe"
                      className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="card-number" className="block text-sm font-medium text-gray-700">
                    Card Number
                  </label>
                  <div className="mt-1 relative rounded-md shadow-sm">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M3 14h18m-9-4v8m-7-8v8m14-8v8" />
                      </svg>
                    </div>
                    <input
                      id="card-number"
                      name="card-number"
                      type="text"
                      autoComplete="cc-number"
                      placeholder="•••• •••• •••• 1234"
                      className="pl-10 appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                    />
                  </div>
                </div>

                <div className="flex space-x-4">
                  <div className="flex-1">
                    <label htmlFor="expiry-date" className="block text-sm font-medium text-gray-700">
                      Expiry Date
                    </label>
                    <div className="mt-1">
                      <input
                        id="expiry-date"
                        name="expiry-date"
                        type="text"
                        autoComplete="cc-exp"
                        placeholder="MM / YY"
                        className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                      />
                    </div>
                  </div>
                  <div className="flex-1">
                    <label htmlFor="cvv" className="block text-sm font-medium text-gray-700">
                      CVV
                    </label>
                    <div className="mt-1">
                      <input
                        id="cvv"
                        name="cvv"
                        type="text"
                        autoComplete="cc-csc"
                        placeholder="•••"
                        className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Other Payment Method (placeholder) */}
            <div className="flex items-center">
              <input
                id="other-payment"
                name="payment-method"
                type="radio"
                className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300"
              />
              <label htmlFor="other-payment" className="ml-3 block text-sm font-medium text-gray-700">
                <span className="sr-only">Other Payment Method</span> {/* For accessibility */}
                {/* You can add text here for other payment methods like "PayPal" */}
              </label>
            </div>

            {/* Billing Address Section */}
            <div className="mt-8">
              <h3 className="text-xl font-bold text-gray-900 mb-4">Billing Address</h3>
              <div className="flex items-center">
                <input
                  id="use-shipping-address"
                  name="use-shipping-address"
                  type="checkbox"
                  checked
                  className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded"
                />
                <label htmlFor="use-shipping-address" className="ml-2 block text-sm text-gray-900">
                  Use shipping address as billing address
                </label>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column: Your Order Summary */}
        <div className="lg:w-1/3 bg-white p-8 rounded-lg shadow-md h-fit sticky top-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-6">Your Order</h2>

          <div className="space-y-4">
            {/* Order Item 1 */}
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-4">
                {/* <img
                  src={whiteningToothpasteImg} 
                  alt="Whitening Toothpaste"
                  className="w-12 h-12 rounded-md object-cover"
                /> */}
                <div>
                  <p className="text-sm font-medium text-gray-900">Whitening Toothpaste</p>
                  <p className="text-xs text-gray-500">Qty: 2</p>
                </div>
              </div>
              <p className="text-sm font-medium text-gray-900">₹18.00</p>
            </div>

            {/* Order Item 2 */}
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-4">
                {/* <img
                  src={charcoalToothpasteImg} 
                  alt="Charcoal Toothpaste"
                  className="w-12 h-12 rounded-md object-cover"
                /> */}
                <div>
                  <p className="text-sm font-medium text-gray-900">Charcoal Toothpaste</p>
                  <p className="text-xs text-gray-500">Qty: 1</p>
                </div>
              </div>
              <p className="text-sm font-medium text-gray-900">₹10.00</p>
            </div>
          </div>

          <hr className="my-6 border-gray-200" />

          {/* Totals */}
          <div className="space-y-2">
            <div className="flex justify-between text-sm text-gray-700">
              <span>Subtotal</span>
              <span>₹28.00</span>
            </div>
            <div className="flex justify-between text-sm text-gray-700">
              <span>Shipping</span>
              <span className="text-green-600">Free</span>
            </div>
            <div className="flex justify-between text-sm text-gray-700">
              <span>Taxes</span>
              <span>₹2.10</span>
            </div>
            <div className="flex justify-between text-lg font-bold text-gray-900 pt-2">
              <span>Total</span>
              <span>₹30.10</span>
            </div>
          </div>

          <button className="mt-8 w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 rounded-md transition shadow-sm">
            Place Order
          </button>

          <div className="mt-4 text-center">
            <a href="/product-details" className="text-blue-600 hover:text-blue-800 text-sm">Return to Cart</a>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="mt-12 text-center text-sm text-gray-500">
        <p>© 2025 Sridanth. All Rights Reserved.</p>
        <div className="flex justify-center space-x-4 mt-2">
          <a href="/terms-and-services" className="text-blue-600 hover:text-blue-800">Terms of Service</a>
          <a href="/privacy-policy" className="text-blue-600 hover:text-blue-800">Privacy Policy</a>
          <a href="/shipping-and-refund-policy" className="text-blue-600 hover:text-blue-800">Customer Support</a>
        </div>
        <p className="flex items-center justify-center mt-2">
          <svg className="h-4 w-4 mr-1 text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v3h8z" />
          </svg>
          SSL Secure Connection
        </p>
      </div>
    </div>
  );
};

export default Payment;